import React, { useState, useEffect } from "react";
import GoogleImg from "../../assests/GoogleImg.png";
import AppleImg from "../../assests/AppleImg.png";
import Logo from "../../assests/logo.jpeg";
import "./Popup.css";

const Popup = () => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const hasPopupShown = sessionStorage.getItem("hasPopupShown");
    if (!hasPopupShown) {
      setIsOpen(true);
      sessionStorage.setItem("hasPopupShown", "true");
    }
  }, []);

  const closePopup = () => {
    setIsOpen(false);
  };

  return (
    <div className={`container ${isOpen ? "open" : ""}`}>
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="close-icon" onClick={closePopup}>
              <div onClick={closePopup} className="CloseBtnPop">
                <i className="fa-solid fa-xmark" />
              </div>
            </div>
            <div className="PopupMessage">
              <div className="popupLogo">
                <img src={Logo} alt="" />
              </div>
              <h2>Download ISCB App</h2>
              <div className="storesDownload">
                <a
                  className="Download-lonks-app"
                  target="_blank"
                  rel="noreferrer"
                  href="https://apps.apple.com/us/app/isbc/id6448773651"
                >
                  <img
                    src={AppleImg}
                    alt="isbc app download Apple play store"
                  />
                </a>
                <a
                  className="Download-lonks-app"
                  href=" https://play.google.com/store/apps/details?id=com.isbc.cricket&hl=en-IN"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={GoogleImg} alt="isbc app download play store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Popup;
